function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Icon from "../Icon/Icon";
import { useGlobalValue } from "../../state/GlobalProvider";
import { createLink, mapProperties } from "../../utils";
import Chevron from "../Chevron/Chevron";
import WidgetSummary from "./WidgetSummary";
import WidgetActions from "./WidgetActions";
import styles from "./Widget.module.sass";
import { SovosTooltip } from 'mosaic-react';
const Widget = props => {
  const {
    data,
    expanded = true,
    close = false,
    onChange,
    title,
    icon,
    link,
    summary,
    children,
    className,
    displayInfo = "",
    modifiers,
    actions,
    entity = "",
    setClose = false,
    summaryWidget = false
  } = props;
  if (Array.isArray(data) && data.length <= 1 && data[0]["summary"] && data[0]["summary"].length === 0) {
    return null;
  }
  const [collapsed, setCollapsed] = useState(!(expanded || link));
  const {
    i18n,
    location,
    params,
    locale,
    queries,
    fetch,
    proxy
  } = useGlobalValue();
  useEffect(() => {
    onChange && onChange({
      target: {
        value: collapsed
      }
    });
  }, [collapsed]);
  useEffect(() => {
    setCollapsed(setClose);
  }, [setClose]);
  const childrenElements = children && Array.isArray(children) ? children.map((spec, index) => {
    const Component = spec.component;
    const componentProps = mapProperties(spec.props, (fetch || {}).results, (fetch || {}).status, queries || [], props, params, i18n, locale);
    return Component && /*#__PURE__*/React.createElement(Component, _extends({
      key: index,
      modifiers: spec.modifiers
    }, componentProps));
  }).filter(c => c) : children;
  const modifiersClasses = (modifiers || []).map(m => styles[m]).filter(m => m).join(" ");
  const translatedTitle = entity === "invoices" ? i18n`Invoice Totals` : Array.isArray(title) ? i18n`${title.join("")}` : title;
  return /*#__PURE__*/React.createElement("div", {
    className: `widget-to-include ${styles["root"]} ${modifiersClasses} ${className || ""}`,
    id: "widget-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: `${styles["header"]} ${!summaryWidget ? styles["clickable"] : ""}`,
    onClick: () => {
      setCollapsed(!collapsed);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles["title-container"]
  }, icon && displayInfo.length === 0 && /*#__PURE__*/React.createElement(Icon, {
    name: icon,
    className: styles["icon"]
  }), title && /*#__PURE__*/React.createElement(SovosTooltip, {
    title: translatedTitle
  }, /*#__PURE__*/React.createElement("h5", null, translatedTitle)), displayInfo.length > 0 && /*#__PURE__*/React.createElement(Icon, {
    name: "info",
    className: styles["informative-icon"],
    iconPlaceholder: `${displayInfo}`
  })), summary && summary.length ? /*#__PURE__*/React.createElement(WidgetSummary, {
    summary: summary
  }) : null, actions && actions.length ? /*#__PURE__*/React.createElement(WidgetActions, {
    actions: actions
  }) : null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-flex"
    }
  }, (childrenElements || link) && /*#__PURE__*/React.createElement("div", {
    className: `${styles['action-button-container']}`
  }, close && /*#__PURE__*/React.createElement("button", {
    className: styles["action-button"],
    onClick: close.onClick
  }, /*#__PURE__*/React.createElement("small", null, /*#__PURE__*/React.createElement("strong", null, i18n`${close.value}`)), /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    className: styles["icon-close"]
  })), !close && link && /*#__PURE__*/React.createElement(Link, {
    className: styles["action-button"],
    to: link.createLink === true ? createLink(undefined, proxy, link, params) : link.to.match(/^\//) ? link.to : `${location.pathname}${location.pathname.match(/\/$/) ? "" : "/"}${link.to}`
  }, /*#__PURE__*/React.createElement("small", null, /*#__PURE__*/React.createElement("strong", null, link.name || i18n`See More`)))), !close && !summaryWidget && /*#__PURE__*/React.createElement(Chevron, {
    direction: collapsed ? "right" : "down"
  }))), /*#__PURE__*/React.createElement("div", {
    className: `${styles["content-container"]} ${styles[`container-is-collapsed-${collapsed}`]} kpis-container`
  }, !collapsed && children && /*#__PURE__*/React.createElement("section", {
    className: styles["content"]
  }, childrenElements)));
};
export default Widget;